import { render, staticRenderFns } from "./FieldDetail.vue?vue&type=template&id=3ed9395e&scoped=true"
import script from "./FieldDetail.vue?vue&type=script&lang=js"
export * from "./FieldDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed9395e",
  null
  
)

export default component.exports